"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var NotificationItem_1 = __importDefault(require("../../NotificationItem"));
var EventStarted_1 = __importDefault(require("../../../Icons/Notifications/EventStarted"));
var i18N = {
    en: {
        description: function (metadata) { return (react_1.default.createElement(react_1.default.Fragment, null,
            "The event ",
            react_1.default.createElement("a", { href: metadata.link }, metadata.name),
            " has begun!")); },
        title: 'Event started'
    },
    es: {
        description: function (metadata) { return (react_1.default.createElement(react_1.default.Fragment, null,
            "El evento ",
            react_1.default.createElement("a", { href: metadata.link }, metadata.name),
            " ha empezado!")); },
        title: 'Evento ha comenzado'
    },
    zh: {
        description: function (metadata) { return (react_1.default.createElement(react_1.default.Fragment, null,
            "\u4E8B\u4EF6 ",
            react_1.default.createElement("a", { href: metadata.link }, metadata.name),
            " \u5DF2\u5F00\u59CB")); },
        title: '事件开始'
    }
};
var EventsStartedNotification = function (_a) {
    var notification = _a.notification, locale = _a.locale;
    return (react_1.default.createElement(NotificationItem_1.default, { image: { image: react_1.default.createElement(EventStarted_1.default, { width: "48", height: "48" }) }, timestamp: notification.timestamp, isNew: !notification.read, locale: locale },
        react_1.default.createElement("p", { className: "dcl notification-item__content-title" }, i18N[locale].title),
        react_1.default.createElement("a", { href: notification.metadata.link },
            react_1.default.createElement("p", { className: "dcl notification-item__content-description" }, i18N[locale].description(notification.metadata)))));
};
exports.default = EventsStartedNotification;
